import { TimelineInputs } from './Timeline';

export const timelineTransformer = (node: any): TimelineInputs => {
    return {
        hide: node.field_timeline_hide?.length > 0,
        title: node.field_component_title,
        items: node.relationships.field_timeline_items.map((item) => {
            return {
                dateText: item.field_timeline_item_date_text,
                title: item.field_component_title,
                icon: item.field_timeline_item_icon,
            };
        }),
    };
};
